import parse from 'html-react-parser';
import { sanitizeQuillHtml } from 'src/components/atoms';

export function sanitizeQuestionnaireDescription(value?: string | null) {
  if (!value) return null;
  return parse(sanitizeQuillHtml(value).replace(/<p>|<\/p>/g, ''));
}
